// import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2 } from "@mui/material";
// import { useEffect, useState } from "react";

// const InformationPopup = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsOpen(true);
//     }, 500); // Show popup after 2 seconds

//     return () => clearTimeout(timer); // Cleanup on unmount
//   }, []);

//   const handleClose = () => {
//     setIsOpen(false);
//   };

//   return (
//     <Dialog
//       open={isOpen}
//       onClose={handleClose}
//       onClick={handleClose}
//       aria-labelledby="alert-dialog-title"
//       aria-describedby="alert-dialog-description"
//       maxWidth="md"
//     >
//       <DialogTitle id="alert-dialog-title">
//         <Grid2 container spacing={2} alignItems="center" justifyContent={"center"}>
// <Grid2 item xs={2} size={"4"} style={{ textAlign: "right" }}>
//   <img
//     src="assets/tennet-w.png"
//     alt="Tennet Logo"
//   />
// </Grid2>
//           <Grid2 item xs={10} size={"8"} style={{ textAlign: "left" }}>
//             <h3 style={{ margin: 0 }}>Informasi Penting untuk Mitra dan Pengguna Layanan</h3>
//           </Grid2>
//         </Grid2>
//       </DialogTitle>
//       <DialogContent>
//         <DialogContentText id="alert-dialog-description">
//           PT Tennet Depository Indonesia, as an independently capitalized entity, is currently registered and undergoing the process in the Otoritas Jasa Keuangan (OJK) Regulatory Sandbox as part of our efforts to eventually obtain full licensing/regulation.
//         </DialogContentText>
//       </DialogContent>
//       <DialogActions style={{ justifyContent: "center" }}>
//         <Button onClick={handleClose}>
//           Tap anywhere to close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default InformationPopup;

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close"; // Pastikan install @mui/icons-material

const InformationPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 500); // Muncul setelah 0.5 detik sesuai kode awalmu

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="sm" // Diubah ke 'sm' agar lebih mirip proporsi di gambar
      fullWidth
      PaperProps={{
        sx: { borderRadius: 4, p: 1 },
      }}
    >
      {/* Tombol X di pojok kanan */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          color: "grey.500",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle sx={{ mt: 2 }}>
        <Grid2 container spacing={2} alignItems="center" justifyContent={"center"}>
          {/* Ikon Perisai Biru (Menggunakan Image atau Icon) */}
          <Grid2 item xs={2} size={"4"} style={{ textAlign: "right" }}>
            <img
              src="assets/tennet-w.png"
              alt="Tennet Logo"
            />
          </Grid2>
          <Typography variant="h4" textAlign="center" fontWeight="800" sx={{ color: "#0f172a", lineHeight: 1.2 }}>
            Informasi Penting untuk Mitra dan Pengguna Layanan
          </Typography>
        </Grid2>
      </DialogTitle>

      <DialogContent sx={{ color: "#334155" }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Sehubungan dengan informasi yang beredar, kami tegaskan bahwa{" "}
          <strong>PT Tennet Depository Indonesia TIDAK TUTUP.</strong>
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Pencabutan izin oleh OJK bersifat spesifik dan hanya terkait dengan layanan dalam ekosistem perdagangan aset kripto.
        </Typography>

        {/* Box Highlight Biru */}
        <Box
          sx={{
            backgroundColor: "#f1f5f9",
            borderLeft: "5px solid #3b82f6",
            p: 2,
            mb: 2,
            borderRadius: "4px",
          }}
        >
          <Typography variant="body1">
            Tennet tetap beroperasi sebagai <strong>peserta sandbox (No. S-326/IK.01/2025)</strong> untuk jasa kustodian aset keuangan digital di luar ekosistem perdagangan.
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ mb: 2 }}>
          Infrastruktur dan tim kami tetap utuh, serta komitmen terhadap keamanan aset dan kepatuhan regulasi terus berjalan sebagaimana mestinya.
        </Typography>

        <Typography variant="body1">
          Kami berterima kasih atas kepercayaan yang terus diberikan oleh para mitra dan pengguna layanan kami.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#1e293b", // Biru gelap cenderung hitam sesuai gambar
            textTransform: "none",
            py: 1.5,
            borderRadius: 2,
            fontSize: "1rem",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#0f172a" },
          }}
        >
          Saya Mengerti
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InformationPopup;